export default {
    modelsLoadedWithNsLoader: {},
    timestampsForModelsdWithNsLoader: {},
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-nsloader/state.js
// module id = null
// module chunks = 